import { render, staticRenderFns } from "./PageAccountSettings.vue?vue&type=template&id=000d4f7e"
import script from "./PageAccountSettings.vue?vue&type=script&lang=js"
export * from "./PageAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports